import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

export const FundraiserSettingsTabNavigation = () => {
  const pageTabs: PageTabItem[] = [
    {
      label: 'fundraiser:tabNavigation.fundraiser',
      route: RoutesEnum.FundraiserSettings,
    },
    {
      label: 'fundraiser:tabNavigation.emailTexts',
      route: RoutesEnum.SettingsFundraiserSettings,
    },
  ];
  return <PageTabNavigation pageTabs={pageTabs} />;
};
